/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Bulk_Category_ErrorInputs */

const vi_toast_expense_bulk_category_error = /** @type {(inputs: Toast_Expense_Bulk_Category_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được danh mục`)
};

/**

* @param {Toast_Expense_Bulk_Category_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_bulk_category_error = /** @type {((inputs?: Toast_Expense_Bulk_Category_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Bulk_Category_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_bulk_category_error(inputs)
});